import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52440bcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center gap-5" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "required mb-1" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = {
  for: "",
  class: "required mb-1"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_7 = {
  class: "required mb-1",
  style: {}
}
const _hoisted_8 = {
  key: 1,
  class: "w-100 px-10"
}
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Conditions", -1))
const _hoisted_11 = { class: "d-flex mt-5" }

import SimpleForm from "@/components/SimpleForm.vue";
import { nextTick, ref } from "vue";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import TenantGlobalService, {
  CreateReportSpec,
} from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { FundTypes, getAllFundTypeSelections } from "@/core/types/FundTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'WalletExportModal',
  setup(__props, { expose: __expose }) {

const modalRef = ref();
const isLoading = ref(false);
const formData = ref({
  type: ReportRequestTypes.WalletOverviewForTenant,
} as any);
const exporting = ref(false);
const period = ref([] as any);
const selectedOption = ref("id");
const inputValue = ref("");
const criteria = ref({
  currencyId: "",
  fundType: "",
});
const currencySelections = ref([]);
const fundTypeSelections = getAllFundTypeSelections([
  FundTypes.Wire,
  FundTypes.Ips,
]);

const submit = async () => {
  const submitHandler = {
    [ReportRequestTypes.WalletTransactionForTenant]: submitReportRequestJob,
    [ReportRequestTypes.WalletOverviewForTenant]: submitReportRequestDownload,
  }[formData.value.type];

  await submitHandler?.();
};

const convertToISO = (prd) => {
  const val = prd.map((x) => (x = x.replace(" ", "T") + "Z"));
  return { from: val ? val[0] : null, to: val ? val[1] : null };
};

const submitReportRequestJob = async () => {
  // const criteria = parsePeriodIntoCriteria(period.value);
  const datesRange = convertToISO(period.value);
  const spec: CreateReportSpec = {
    type: ReportRequestTypes.WalletTransactionForTenant,
    name: formData.value.name,
    query: datesRange,
  };
  try {
    exporting.value = true;
    await TenantGlobalService.createReportRequest(spec);
    MsgPrompt.success(
      'Report request has been created, go to "Report", "Report Record" to download'
    ).then(hide);
    // const media = await TenantGlobalService.createReportRequestDownload(spec);
    // await TenantGlobalService.downloadFileByGuid(media.guid, media.fileName);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    exporting.value = false;
  }
};
const submitReportRequestDownload = async () => {
  await configCriteria();
  const spec: CreateReportSpec = {
    type: ReportRequestTypes.WalletOverviewForTenant,
    name: formData.value.name,
    query: {
      ...criteria.value,
    },
  };
  try {
    exporting.value = true;
    const media = await TenantGlobalService.createReportRequestDownload(spec);
    await TenantGlobalService.downloadFileByGuid(media.guid, media.fileName);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    exporting.value = false;
  }
};

const resetCriteria = () => {
  criteria.value.currencyId = "";
  criteria.value.fundType = "";
  selectedOption.value = "id";
  inputValue.value = "";
};

const configCriteria = async () => {
  delete criteria.value.id;
  delete criteria.value.email;
  delete criteria.value.accountUid;
  if (inputValue.value !== null && inputValue.value.trim() !== "") {
    criteria.value[selectedOption.value] = inputValue.value;
  }
};

const show = async (_criteria?: any, _currencySelections?: any) => {
  fillCriteria(_criteria, _currencySelections);
  await nextTick();
  modalRef.value?.show();
};

const fillCriteria = (_criteria, _currencySelections) => {
  if (_criteria) {
    criteria.value.currencyId = _criteria.currencyId;
    criteria.value.fundType = _criteria.fundType;
    if (_criteria.id === 0 || _criteria.id === null) {
      selectedOption.value = _criteria.email === null ? "accountUid" : "email";
      inputValue.value =
        _criteria.email === null ? _criteria.accountUid : _criteria.email;
    } else {
      selectedOption.value = "id";
      inputValue.value = _criteria.id;
    }
  }
  if (_currencySelections) {
    currencySelections.value = _currencySelections;
  }
};

const hide = () => {
  modalRef.value?.hide();
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('action.export'),
    "is-loading": isLoading.value,
    width: 500,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("title.recordName")), 1),
          _createVNode(_component_el_input, {
            class: "w-400px",
            modelValue: formData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("fields.type")), 1),
          _createVNode(_component_el_select, {
            modelValue: formData.value.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.type) = $event)),
            class: "w-400px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('fields.walletOverview'),
                value: _unref(ReportRequestTypes).WalletOverviewForTenant
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('fields.walletTransactionDetails'),
                value: _unref(ReportRequestTypes).WalletTransactionForTenant
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (formData.value.type === _unref(ReportRequestTypes).WalletTransactionForTenant)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("fields.period")), 1),
              _createVNode(_component_el_date_picker, {
                class: "w-400px",
                modelValue: period.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((period).value = $event)),
                type: "datetimerange",
                "start-placeholder": _ctx.$t('fields.startDate'),
                "end-placeholder": _ctx.$t('fields.endDate'),
                format: "YYYY-MM-DD HH:mm:ss",
                "value-format": "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_el_divider),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_el_button, { onClick: resetCriteria }, {
                  default: _withCtx(() => [
                    _createTextVNode("Reset Conditions")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form, {
                "label-width": "auto",
                class: "border"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "Search Type" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: selectedOption.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedOption).value = $event)),
                        placeholder: "Select option",
                        disabled: exporting.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Wallet ID",
                            value: "id"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Email",
                            value: "email"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Account UID",
                            value: "accountUid"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Keywords" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: inputValue.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputValue).value = $event)),
                        disabled: exporting.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Currency" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-125px",
                        modelValue: criteria.value.currencyId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((criteria.value.currencyId) = $event)),
                        placeholder: _ctx.$t('fields.currency'),
                        disabled: exporting.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "-- All --",
                            value: ""
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencySelections.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Fund Type" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-125px",
                        modelValue: criteria.value.fundType,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.fundType) = $event)),
                        placeholder: _ctx.$t('fields.fundType'),
                        disabled: exporting.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "-- All --",
                            value: ""
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fundTypeSelections), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "primary",
            loading: exporting.value,
            onClick: submit,
            disabled: !formData.value.type || !formData.value.name
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          _createVNode(_component_el_button, { onClick: hide }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})